<script lang="ts" setup>
  import { ErrorMessage } from 'vee-validate';
  import type { HTMLAttributes } from 'vue';
  import { toValue } from 'vue';

  import { cn } from '@ui/utils/utils';

  import { useFormField } from './useFormField';

  const props = defineProps<{
    class?: HTMLAttributes['class'];
  }>();

  const { formMessageId, name } = useFormField();
</script>

<template>
  <ErrorMessage
    :id="formMessageId"
    data-slot="form-message"
    as="p"
    :name="toValue(name)"
    :class="cn('text-destructive text-sm', props.class)"
  />
</template>
